import { ProductType } from '../common/enums'

export function determineProductType(productId: number) {
  return (
    {
      [1]: ProductType.RIC1010,
      [2]: ProductType.RIC1020,
      [3]: ProductType.RIC1030,
    }[productId] || ProductType.RIC1030
  )
}
